import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";
import { toast } from "react-hot-toast";

export const deleteQuickAccessApi = createAsyncThunk(
    'quickAccess/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.delete(apiRoutes.quickAccessAction(id, 1));
            toast.success(response?.data?.message || "Quick Access Deleted Successfully", {
                id: "toast",
                duration: 2000,
                position: "top-center",
            });
            return response?.data;
        } catch (error) {
            let errorMsg = error?.response?.data?.message || "Something went wrong";
            if (typeof errorMsg === 'object') {
                errorMsg = Object.values(errorMsg).flat().join(', ');
            }
            toast.error(errorMsg, {
                id: "toast",
                duration: 2000,
                position: "top-center",
            });
            return rejectWithValue(error?.response?.data);
        }
    }
);

const deleteQuickAccessSlice = createSlice({
    name: 'deleteQuickAccess',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetDeleteQuickAccess: (state) => {
            state.result = [];
            state.loading = false;
            state.error = null;
            state.message = "";
        }
    },
    extraReducers: (builder) => {
        builder.addCase(deleteQuickAccessApi.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteQuickAccessApi.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action?.payload?.result;
            state.message = action?.payload?.message;
        });
        builder.addCase(deleteQuickAccessApi.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload?.error;
            state.message = action?.payload?.message;
        });
    },
});

export const { resetDeleteQuickAccess } = deleteQuickAccessSlice.actions;
export const deleteQuickAccessReducer = deleteQuickAccessSlice.reducer;
